/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slot_Name_HelpInputs */

const en_slot_name_help = /** @type {(inputs: Slot_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave empty for the default name.`)
};

const de_slot_name_help = /** @type {(inputs: Slot_Name_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer lassen für den Standardnamen.`)
};

/**
* | output |
* | --- |
* | "Leave empty for the default name." |
*
* @param {Slot_Name_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slot_name_help = /** @type {((inputs?: Slot_Name_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slot_Name_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_slot_name_help(inputs)
	return en_slot_name_help(inputs)
});